import produce from 'immer';
import { COMPONENT_TYPE as TYPE, UNIFORM_PROPS } from 'common/constants';
import { generateNodeId } from 'common/utils/generate-id';
import { BUTTON } from 'client/components/common/BuildingBlocks/Button';

/**
 * @param options {Object=}
 * @param options.dictionary {Object=}
 * @returns {{ view, model }}
 * @constructor
 */
export const BUTTON_SUBMIT = (options = { dictionary: {} }) => {
	const Button = BUTTON({ ...options, type: TYPE.BUTTON_SUBMIT });
	return {
		view: Button.view,
		get model() {
			return produce(Button.model, acc => {
				acc.uiConfig.editorProps.name = BUTTON_SUBMIT.displayName;
				acc.uiConfig.componentProps[UNIFORM_PROPS.btnSubmit] = true;
				acc.uiConfig.nodeProps.id = generateNodeId(acc._id, BUTTON_SUBMIT.displayName);
			});
		},
	};
};

BUTTON_SUBMIT.displayName = 'Submit';
